import {
  ACTION_UPLOAD_FAVICON__REQUEST,
  ACTION_UPLOAD_FAVICON__SUCCESS,
  ACTION_UPLOAD_FAVICON__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_UPLOAD_FAVICON__REQUEST:
    case ACTION_UPLOAD_FAVICON__SUCCESS:
      return null;

    case ACTION_UPLOAD_FAVICON__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
